import { ITopUpService } from "./topup_service";
import { AppServices, AngularServices } from "../helpers/config_keys";
import { MessageBox } from "../helpers/message_box";

class TopUpRequestCtrl {
    monies: { value: number; text: string; }[];
    newRecord: any = {};
    info: any;
    loading: boolean;
    saving: boolean;
    rate: number = 0.031;
    amounts = [5, 10, 20, 50, 100, 150, 200, 500, 1000]
    types = [{ id: 'Sms', text: 'SMS Credit' }/*, { id: 'Email', text: 'Email Credit' }*/]
    networks = [
        { code: 'Mtn', name: 'MTN Mobile Money' },
        { code: 'Vodafone', name: 'Vodafone Cash' },
        { code: 'Aitel', name: 'Airtel Money' },
        { code: 'Tigo', name: 'Tigo Cash' }
    ];

    static $inject = [AppServices.TopUpService, AngularServices.StateParams, "$filter"];
    constructor(private topupService: ITopUpService,
        private $stateParams: angular.ui.IStateParamsService, private $filter: angular.IFilterService) {
        let apiKey = $stateParams['apikey']
        if (apiKey) this.getAccountDetail(apiKey)
    }

    private setUpAmountPackages(rate: number) {
        this.monies = this.amounts.map((amount) => {
            const msg = this.$filter('number')((amount / rate), 0)
            const amt = this.$filter('currency')(amount, "GH¢")
            return { value: amount, text: `${amt} for ${msg} messages` }
        });
    }

    private getAccountDetail(apiKey: string) {
        this.loading = true
        this.topupService.getAccountInfo(apiKey).then((res) => {
            this.loading = false
            if (res.success) {
                this.info = angular.copy(res.data);
                this.setUpAmountPackages(this.info.cost)
            }
        })
    }

    makeRequest(request: any) {
        let win: any = window
        this.saving = true
        if (this.info) request.email = this.info.email
        request.type = "Sms"
        this.topupService.makeRequest(request).then((res) => {
            this.saving = false
            if (res.success) {
                this.newRecord = null
                MessageBox.info("We are done here. Confirm the transaction on your phone and we will update your account balance.")
            }
        })
    }
}

export { TopUpRequestCtrl }


// WEBPACK FOOTER //
// ./app/topup/request_ctrl.ts